import { inject, injectable } from 'inversify';
import {
  CategoriesByStoreParams,
  CategoriesRepositoryInterface,
} from '../domain/CategoriesRepositoryInterface';
import type { CategoriesServiceInterface } from 'features/categories/data/service/CategoriesService.types';
import CategoriesService from 'src/features/categories/data/service/CategoriesService';

@injectable()
class CategoriesRepository implements CategoriesRepositoryInterface {
  @inject(CategoriesService)
  private categoriesService!: CategoriesServiceInterface;

  async getAll() {
    const response = await this.categoriesService.getAll();
    return response.data;
  }

  async getByStoreSlug({ storeSlug }: CategoriesByStoreParams) {
    const response = await this.categoriesService.getByStoreSlug({ storeSlug });
    return response.data;
  }
}

export default CategoriesRepository;
